export function calcTotals(partidas, ivaRate = 0.21) {
  const base = (partidas || []).reduce(
    (acc, p) => acc + (Number(p.cantidad) || 0) * (Number(p.precio_unitario) || 0),
    0
  );
  const iva = base * ivaRate;
  return {
    base: round2(base),
    iva: round2(iva),
    total: round2(base + iva),
  };
}

export function round2(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

export function parsePrecioCatalogo(val) {
  if (val == null || val === "") return 0;
  if (typeof val === "number" && Number.isFinite(val)) return val;
  const s = String(val).replace(/\s/g, "").replace(/€/g, "").trim();
  if (!s) return 0;
  if (s.includes(",")) {
    const i = s.lastIndexOf(",");
    const entero = s.slice(0, i).replace(/\./g, "");
    const dec = s.slice(i + 1);
    const n = Number(`${entero}.${dec}`);
    return Number.isFinite(n) ? n : 0;
  }
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
}

export function fmtEUR(n) {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(Number(n) || 0);
}

export function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
